module.exports = __webpack_public_path__ + "static/img/s508.bbbf880.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s508.png
// module id = 570
// module chunks = 3